<template>
  <div class="container">
    <div class="row">
      <!--Previous Recordings-->
      <div class="col-sm-12 text-center" v-if="completedCeremonies.length > 0">
        <hr />
        <h3>Previous Recordings</h3>

        <div v-for="ceremony in completedCeremonies" :key="ceremony.gradDate" class="previous-recording-container">
            <div v-for="(type, index) in ceremony.gradType" :key="index" class="previous-recording-title">
              <h4>{{ type }}</h4>
            </div>
            <div class="previous-recording-button">
              <a class="btn btn-primary" :id="'watch-btn-' + ceremony.id">
              <!-- <i class="fa fa-television icon-large"></i>
              <i class="fa fa-tablet icon-large"></i>
              <i class="fa fa-mobile fa-lg"></i> -->
              <i class="fa fa-video-camera"></i> &nbsp;
                Watch the {{ formattedDateTime(ceremony.gradDate) }} Ceremony!</a>
            </div>
            <div class="video-container col-md-12 text-center" :id="'video-embed-' + ceremony.id">
              <iframe width="640" height="360" :src="ceremony.streamingVid" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="CSUB Commencement Video">
                Your browser cannot display iFrames. <a :href="ceremony.streamingVid">Watch the video.</a>
              </iframe>
            </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center getAdobe">
          <br />
          <div class="tintup" data-id="event_csub2017pacwest_1495126703" data-columns="" data-expand="true" data-infinitescroll="true" data-personalization-id="862767" v-show="false"></div>
          <hr />
          &copy; California State University, Bakersfield
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ceremonies', 'allCeremoniesCompleted'],
  data () {
    return {
      completedCeremonies: [] // To store the completed ceremonies
    }
  },
  mounted () {
    // Get the completed ceremony data
    this.getCompletedCeremonies()
  },
  updated () {
    // Store the Vue instance
    let vm = this

    $(document).ready(function () {
      // Prevous recording buttons
      // Add slide toggle for each "Watch" button to show corresponding video
      for (let i = 0; i < vm.completedCeremonies.length; i++) {
        let watchBtn = $('#watch-btn-' + vm.completedCeremonies[i].id)
        let event = $._data(watchBtn[0], 'events')
        let hasEvents = (event != null)

        if (!hasEvents) {
          watchBtn.click(function () {
            $('#video-embed-' + vm.completedCeremonies[i].id).slideToggle()
          })
        }
      }
    })
  },
  watch: {
    ceremonies: { // Track updates to ceremonies array from from parent component (allCeremonies.vue)
      handler (newArray, oldArray) {
        this.getCompletedCeremonies() // Get the completed ceremony data
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCompletedCeremonies: function () { // Get the latest ceremony data
      // Store completed ceremonies
      this.completedCeremonies = this.ceremonies.filter(el => el.completed)
    },
    formattedDateTime: function (dateTime) { // Return ceremony date/time in friendly format for "Watch" buttons
      let originalDateTime = new Date(dateTime)
      let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let hours = originalDateTime.getHours()
      let minutes = originalDateTime.getMinutes()
      let amPm = hours >= 12 ? 'p.m.' : 'a.m.'
      hours = (hours % 12) || 12
      minutes = (minutes === 0) ? '00' : minutes
      let formattedDateTime = months[originalDateTime.getMonth()] + ' ' + originalDateTime.getDate() + ', ' + originalDateTime.getFullYear() + ' ' + hours + ':' + minutes + ' ' + amPm
      return formattedDateTime
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    font-size: 14px;
  }

  h2 {
    color: #ffd700;
    font-weight: bold;
    text-shadow: 2px 2px 10px black;
  }

  h3, .h3 {
    color: #ffd700;
    margin-bottom: 30px;
  }

  h4 {
    font-weight: bold;
    margin-bottom: 20px;
  }

  .previous-recording-container:not(:last-child) {
    margin-bottom: 40px;
  }

  .previous-recording-title {
    font-size: 16px;
  }

  .previous-recording-button {
    margin-top: 15px;
  }

  .video-container {
    display: none;
    margin: 20px 0 40px;
  }

  .video-container iframe {
    width: 100%;
    max-width: 640px;
    max-height: 360px;
    display: block;
    margin: auto;
  }

  .getAdobe {
    margin: 0;
    font-size: 14px;
  }

  .getAdobe hr {
    width: 50%;
    /* color: #ebebeb; */
  }

  .getAdobe a:link, .getAdobe a:visited {
    color: #ebebeb;
  }

  a[id^='watch-btn-'] {
    /* background-color: #357E35; */
    background-color: #ffc72c;
    color: #003594;
    border: none;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
    transition: all 0.2s;
    padding: 12px;
    font-size: 16px;
    margin-bottom: 20px;
  }

  a[id^='watch-btn-']:hover {
    background-color: #001a70;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/completedCeremonies.vue